import { motion } from 'framer-motion';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { CROPS } from './yieldConstants';

export function StepCrop({ form, set }) {
  return (
    <div className="space-y-6">
      <div>
        <Label className="text-xs uppercase tracking-widest text-muted-foreground">Cosa coltivi?</Label>
        <div className="mt-3 grid grid-cols-3 sm:grid-cols-5 gap-2">
          {CROPS.map(({ v, l, I }) => {
            const on = form.crop === v;
            return (
              <motion.button key={v} type="button" whileTap={{ scale: 0.94 }} onClick={() => set('crop', v)} data-testid={`yield-crop-${v}`}
                             className={`relative rounded-2xl border p-3 flex flex-col items-center gap-2 text-xs font-medium transition-colors ${on ? 'border-chartreuse bg-chartreuse/10 text-foreground' : 'border-border hover:border-chartreuse/40 text-muted-foreground'}`}>
                {on && <motion.span layoutId="cropOn" className="absolute inset-0 rounded-2xl ring-1 ring-chartreuse shadow-[0_0_24px_-6px_rgba(180,255,0,0.6)]"/>}
                <I size={22} className={on ? 'text-chartreuse' : ''} strokeWidth={1.6}/>
                {l}
              </motion.button>
            );
          })}
        </div>
      </div>

      <div>
        <Label className="text-xs uppercase tracking-widest text-muted-foreground">Quanto è grande?</Label>
        <div className="mt-3 flex p-1 rounded-full bg-secondary/60 text-xs font-semibold w-fit">
          {[['hectares', 'Ettari'], ['trees', 'Numero piante']].map(([v, l]) => (
            <button key={v} type="button" onClick={() => set('sizeMode', v)} data-testid={`yield-size-mode-${v}`}
                    className={`relative px-4 h-8 rounded-full transition-colors ${form.sizeMode === v ? 'text-obsidian' : 'text-muted-foreground'}`}>
              {form.sizeMode === v && <motion.span layoutId="sizeMode" className="absolute inset-0 rounded-full bg-chartreuse"/>}
              <span className="relative">{l}</span>
            </button>
          ))}
        </div>
        <div className="mt-3 relative">
          {form.sizeMode === 'hectares' ? (
            <Input type="number" inputMode="decimal" step="0.1" min="0" placeholder="es. 8,5" value={form.area_hectares}
                   onChange={e => set('area_hectares', e.target.value)} data-testid="yield-hectares-input" className="h-14 text-2xl font-display pr-16"/>
          ) : (
            <Input type="number" inputMode="numeric" min="0" placeholder="es. 1200" value={form.number_of_trees}
                   onChange={e => set('number_of_trees', e.target.value)} data-testid="yield-trees-input" className="h-14 text-2xl font-display pr-20"/>
          )}
          <span className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">{form.sizeMode === 'hectares' ? 'ettari' : 'piante'}</span>
        </div>
      </div>

      <div>
        <Label className="text-xs uppercase tracking-widest text-muted-foreground">Varietà <span className="normal-case tracking-normal">(facoltativa)</span></Label>
        <Input placeholder="es. Coratina, Sangiovese, Tarocco…" value={form.variety} onChange={e => set('variety', e.target.value)}
               data-testid="yield-variety-input" className="mt-2"/>
      </div>
    </div>
  );
}
